import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent {
  public openHelpDialog = false;

  public openHelpModal = (): void => {
    this.openHelpDialog = true;
  };
  public navigateToSyncWebPanel(): void {
    window.location.href = `${environment.cphost}/login`;
  }
  public openSyncCom(): void {
    window.location.href = 'https://www.sync.com/';
  }
}
